export default __webpack_public_path__ + "static/illustration-6-cropped-e4de80b214c35ff0ed9d24b1706b9132.png";